import * as PropTypes from "prop-types"
import React from "react"
import { NavLink, useLocation } from "react-router-dom"
import { getLocale } from "../helpers"

import LanguageMenu from "./LanguageMenu"

const Navigation = ({ list, modifier, onClick, showLangMenu, handleLanguageChange, availableLang, userLang, isItaly }) => {
  const location = useLocation()
  const locale = getLocale()

  return (
    <nav className={`navigation navigation--${modifier}`}>
      <ul className="navigation__items">
        {list.map(({ slug, pageTitle, icon }, index) => {
          const key = `ni-${index}`
          const path = slug ? `/${slug}` : ""
          const link = locale ? `/${locale}${path}` : path

          return (
            pageTitle && (
              <li key={key} className="navigation__item">
                {modifier === "categories" && icon && (
                  <div className="icon">
                    <img src={icon} alt="" />
                  </div>
                )}

                <NavLink
                  to={link}
                  end
                  className={({ isActive }) => {
                    // const isAllGames = pageTitle === translations?.links?.allGames
                    const isHome = pageTitle === "Home Page"

                    let active = false

                    if (isHome) {
                      // All Games active ONLY on exact homepage
                      active = location.pathname === "/it"
                    } else {
                      // Categories (or other links) use router matching
                      active = isActive
                    }

                    return ["navigation__link", active ? "navigation__link--active" : ""].join(" ")
                  }}
                  onClick={onClick}
                >
                  {pageTitle}
                </NavLink>
              </li>
            )
          )
        })}

        {isItaly && (
          <li className="navigation__item">
            <NavLink to="https://concorso.leovegasplay.it" className="navigation__link" onClick={onClick}>
              Concorsi
            </NavLink>
          </li>
        )}
      </ul>

      {showLangMenu && <LanguageMenu handleLanguageChange={handleLanguageChange} availableLang={availableLang} userLang={userLang} />}
    </nav>
  )
}

Navigation.propTypes = {
  list: PropTypes.arrayOf(PropTypes.any).isRequired,
  modifier: PropTypes.string,
  onClick: PropTypes.func,
  showLangMenu: PropTypes.bool,
  handleLanguageChange: PropTypes.func,
  availableLang: PropTypes.arrayOf(PropTypes.any),
  userLang: PropTypes.string,
  isItaly: PropTypes.string
}

Navigation.defaultProps = {
  modifier: "",
  onClick: () => {},
  showLangMenu: false,
  handleLanguageChange: null,
  availableLang: null,
  userLang: null,
  isItaly: false
}

export default Navigation
